import { useSelector } from 'react-redux';
import tenantsService from 'src/services/tenantService';
import { PROFILING } from 'src/utils/profilingKeys';
import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';
import authService from 'src/services/authService';
import configService from 'src/services/configService';

class UserInfo {
	is = autority => {
		if (autority == undefined) return true;

		const account = useSelector(state => state.account);
		if (account.user.authorities) {
			for (var item of account.user.authorities) {
				if (item.id === autority) return true;
			}
		}
		return false;
	};

	can = func => {
		if (func == undefined) return true;

		const account = useSelector(state => state.account);

		if (account.user.allFunctions) {
			for (var f of account.user.allFunctions) {
				if (f.id == func || this.wildcardRegexpMatch(func, f.id) == true)
					return true;
			}
		}

		return false;
	};
	isLegal = () => {
		return this.can(PROFILING.ROLE.LEGAL);
	};
	isCustomerCare = () => {
		return this.can(PROFILING.ROLE.EXTERNAL) && !this.can(PROFILING.ROLE.LEGAL) && !this.can(PROFILING.ROLE.BO_AGENCY);
	};
	isBackofficeAgency = () => {
		return this.can(PROFILING.ROLE.BO_AGENCY);
	}
	isBo = () => {
		return this.can(PROFILING.ROLE.BO);
	};
	isCustomer = () => {
		return (
			this.can(PROFILING.ROLE.CUSTOMER) &&
			!this.can(PROFILING.ROLE.AGENCY) &&
			!this.can(PROFILING.ROLE.AGENT) &&
			!this.can(PROFILING.ROLE.BO) &&
			!this.can(PROFILING.ROLE.EXTERNAL)&&
			!this.can(PROFILING.ADMIN)
		);
	};
	isAgent = () => {
		return this.can(PROFILING.ROLE.AGENT) && !this.can(PROFILING.ROLE.BO) && !this.can(PROFILING.ROLE.EXTERNAL);
	};
	isAgency = () => {
		return this.can(PROFILING.ROLE.AGENCY) && !this.can(PROFILING.ROLE.BO) && !this.can(PROFILING.ROLE.EXTERNAL);
	};

	isCustomerSelfContracts = () => {
		const account = useSelector(state => state.account);
		return account.user.groups?.some(g => g.name === PROFILING.SELF_CONTRACTS.GROUP_NAME) || false;
	};

	agent = () => {
		const account = useSelector(state => state.account);
		const tenantId = tenantsService.getCurrentTenant()?.id;

		if (account.user.allFunctions) {
			let func = account.user.allFunctions.find(
				f => f.id === PROFILING.ROLE.AGENT
			);
			if (func && account.user.extensions?.profiles) {
				let profile = account.user.extensions.profiles.find(
					f => f.tenantId === tenantId
				);
				if (profile) return profile.bpartnerId;
			}
		}

		return undefined;
	};

	getBpartner = () => {
		const account = useSelector(state => state.account);
		const tenantId = tenantsService.getCurrentTenant()?.id;
		let bpartner = null;
			if (account.user.extensions?.profiles) {
				let profile = account.user.extensions.profiles.find(
					f => f.tenantId === tenantId
				);
				if (profile) {
					bpartner = {id:profile?.bpartnerId , name:profile?.bpartnerName}
				}
			}

		return bpartner;
	};

	getLogoCobranding(size) {
		let defaultLogo = '';
		//let defaultLogo = '/static/images/logo-eportal.png';
		let token = authService.getAccessToken();

		if (token) {

			if(size === 'large') { // non usato per ora
				return axios({
					method: 'GET',
					url: `${URLS.BPARTNERS}/logoLarge`,
					responseType: 'blob',
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(res => window.URL.createObjectURL(new Blob([res.data])))
				.catch(() => defaultLogo);
	
			} else if (size === 'small') {
				return axios({
					method: 'GET',
					url: `${URLS.BPARTNERS}/logoSmall`,
					responseType: 'blob',
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(res => new Blob([res.data]).size>0 ? URL.createObjectURL(new Blob([res.data])) : null
				/*{ // cosi non funziona
					console.log(res);
					console.log(res.data);
					const file = new Blob([res.data]);
					//console.log(file);
					//Build a URL from the file
					if (file!=null && file.size>0) {
						console.log('crea url');
						URL.createObjectURL(file);
					}
					//window.URL.createObjectURL(new Blob([res.data]))
				}*/
				)
				.catch(() => defaultLogo);
			}	
			//console.log('resolve');
			return new Promise((resolve) => resolve(defaultLogo));
			//return null;
		} 
	}

	getLogoAziendale() {
		let token = authService.getAccessToken();
		if (token) {
			return axios({
				method: 'GET',
				url: URLS.BPARTNERS_LOGO_SOST_SMALL,
				responseType: 'blob',
				headers: { Authorization: `Bearer ${token}` }
			})
			.then(res => new Blob([res.data]).size > 0 ? URL.createObjectURL(new Blob([res.data])) : null)
			.catch(() => null);
		}
		return Promise.resolve(null);
	}

	getUserWorkspace() {
		let userWorkspace = `${URLS.PROFILES.MY_WORKSPACE_ID}`;
		return axios.get(userWorkspace);
	}

	wildcardRegexpMatch = (func, wildcardFunction) => {
		// Trasforma wildCardFunction in reg exp
		var s = '^';
		for (var i = 0; i < wildcardFunction.length; i++) {
			var funcChar = wildcardFunction.charAt(i);
			if (funcChar == '*') {
				s += '.*';
			} else if (funcChar == '.') {
				s += '\\.';
			} else {
				s += funcChar;
			}
		}
		s += '$';
		// console.log("La funzione utente: " + wildcardFunction + " ==> " + s + " - " + func);

		var re = new RegExp(s);

		// console.log("Result RE: " + (re.test(func)) );
		return re.test(func);
	};
}

const userInfo = new UserInfo();

export default userInfo;
